import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	quickSearchNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findWorkNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	askAiNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aiSearchShortNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	quickSearchNonFinal: {
		id: 'atlassian-intelligence.common.ui.ai-button.quick-search-non-final',
		defaultMessage: 'Quick search',
		description: 'Label displayed in the "Natural Language to JQL" toggle button',
	},
	findWorkNonFinal: {
		id: 'atlassian-intelligence.common.ui.ai-button.find-work-non-final',
		defaultMessage: 'Find work',
		description: 'Label displayed in the "Natural Language to JQL" toggle button',
	},
	askAiNonFinal: {
		id: 'atlassian-intelligence.common.ui.ai-button.ask-ai-non-final',
		defaultMessage: 'Ask AI',
		description: 'Label displayed in the "Natural Language to JQL" toggle button',
	},
	aiSearchShortNonFinal: {
		id: 'atlassian-intelligence.common.ui.ai-button.ai-search-short-non-final',
		defaultMessage: 'AI',
		description:
			'Label displayed in the AI button. Only visible on small screens. Should be very short and concise.',
	},
});
export default messages;
